import React from 'react';
import { AudioPlayerProps } from '../type';
import { Player } from './Player';
import { getValueBinding } from '../../shared';

const voidFunc = () => {};
export const PlayerCanvas: React.FC<AudioPlayerProps> = (props) => {
  const bindingValue = getValueBinding(
    props.record ? props.initId : props.id,
    props.record ? props?.record : props.data,
    props
  );
  const title = bindingValue?.title?.toString() || '';
  const autoPlay = bindingValue?.autoPlay?.toString() === 'true';
  return (
    <Player
      {...props}
      onDownload={voidFunc}
      onPlayPause={voidFunc}
      onSeek={voidFunc}
      onSeekBackward={voidFunc}
      onSeekForward={voidFunc}
      time={30}
      duration={120}
      isPlaying={autoPlay}
      title={title}
    />
  );
};
